export enum InsightResolution {
  Hour = 'hour',
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'Year',
  Decade = 'decade'
}

export interface InsightPoint {
  points: Record<string, any>,
  timestamp: string,
  total: number
}
